import { render, staticRenderFns } from "./List.vue?vue&type=template&id=da4cdd3a&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=less&"
import style1 from "./List.vue?vue&type=style&index=1&id=da4cdd3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4cdd3a",
  null
  
)

export default component.exports